module.exports = __webpack_public_path__ + "img/mainText.de4e980b.png";